// 一些全局的config配置
const modeUrlObj = {
  // 生产环境
  production: {
    // weChatWG
    baseURL: "weChat",
    authBaseURL: `http://${document.domain}`,
    projectName: "JNJT"
  },
  // 开发环境
  development: {
    baseURL: "weixin",
    authBaseURL: `http://roadms.sdzbkj.cn`, //http://chen.cyptjwmsbt.online  wcx.cyptjwmsbt.online
    projectName: "JNJT"
  },
  // 测试环境
  test: {
    baseURL: "",
    authBaseURL: "",
    projectName: "JNJT" //切换项目字典表使用 enumObject.PayConfigCCB 目前使用：南京南站
  }
};
export default modeUrlObj[process.env.NODE_ENV];
